import type { TestShackReportColumn } from "../models/TestShackReportSectionRev";

export const formatDeltaCode = (code: string) =>
	code.startsWith("D.") ? `Δ${code.slice(2)}` : code;

// Without any spec the card's "No Specification" chip already says it all.
export const showsNoSpecMarkers = (columns: TestShackReportColumn[]) =>
	columns.some((column) => column.hasSpec);

export const hasMissingSpecs = (columns: TestShackReportColumn[]) =>
	showsNoSpecMarkers(columns) && columns.some((column) => !column.hasSpec);
